module.exports = __webpack_public_path__ + "static/media/loader.9a7f2d4a.gif";